export const CREATE_EXPENSE_RECORD = "CREATE_EXPENSE_RECORD";
export const FETCH_EXPENSE_RECORDS = "FETCH_EXPENSE_RECORDS";
export const FETCH_EXPENSE_RECORD = "FETCH_EXPENSE_RECORD";
export const EDIT_EXPENSE_RECORD = "EDIT_EXPENSE_RECORD";
export const DELETE_EXPENSE_RECORD = "DELETE_EXPENSE_RECORD";
